export default __webpack_public_path__ + "static/media/background-texture_wood-floor.81f03761.png";